function showTimeslotsDiv(value) {
  if (value == 'true') {
    $('.event_timeslot').show();
  }
  else {
    $('.event_timeslot').hide();
  }
}

$(document).ready(function(){
  const rsvp_value = $("input[type=radio][name='campaign[is_event]']:checked").val()

  if (rsvp_value == 'true') {
    showTimeslotsDiv(rsvp_value);
  }
  else {
    $('.event_timeslot').hide();
  }

  $("input[type=radio][name='campaign[is_event]']").change(function() {
    showTimeslotsDiv(this.value);
  });

});